import React from 'react';
import { Link } from 'react-router-dom';

// Checkout is handled via Stripe redirect from ServiceDetail
// This page handles the return flow
export default function Checkout() {
  return (
    <div className="page">
      <div className="container text-center" style={{ maxWidth: 500, margin: '80px auto' }}>
        <div style={{ fontSize: '4rem', marginBottom: 16 }}>🛒</div>
        <h2>Processing your order...</h2>
        <p className="text-light mt-1">You should be redirected to Stripe checkout. If not, go back and try again.</p>
        <Link to="/browse" className="btn btn-primary mt-3">Back to Browse</Link>
      </div>
    </div>
  );
}
